// extracted by mini-css-extract-plugin
export default {"container":"payment-details_container__5b266","creditRemaining":"payment-details_creditRemaining__9be57","paymentTypeLogo":"payment-details_paymentTypeLogo__62a4b"};